import { useContext, useEffect, useState } from "react";
import { Onfido } from "onfido-sdk-ui";
import TenantContext from "../../context/tenant/TenantContext";
import SkorDefaultLoader from "../../assets/img/skorDefaultLoader.gif";
import { toast, haveValue, MOCK_ONFIDO } from "../../helper/common";
import jwtDecode from "jwt-decode";
import useTranslator from "../../hooks/useTranslator";
const ExtKycVerification = () => {
  const { _t } = useTranslator();
  const { extTenantOnfidoKyc, initiateModuleUserKyc } =
    useContext(TenantContext);
  const [onfidoInitiateLoading, setOnfidoInitiateLoading] = useState(false);
  const [tokenNotFound, setTokenNotFound] = useState(false);
  const [kycSuccess, setKycSuccess] = useState(false);
  const [userToken, setUserToken] = useState({
    tenant_id: "",
    raw_token: "",
    user_token: "",
  });
  /**
   * 1️⃣ Read token ONCE and remove from URL
   */
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = queryParams.get("token");
    if (!tokenFromUrl) {
      setTokenNotFound(true);
      return;
    }
    try {
      const decoded = jwtDecode(tokenFromUrl);
      if (!decoded?.tenant_id) {
        setTokenNotFound(true);
        return;
      }
      setUserToken({
        tenant_id: decoded.tenant_id,
        user_token: decoded.user_key,
        raw_token: tokenFromUrl,
      });
      // ✅ Remove token from URL
      window.history.replaceState({}, document.title, window.location.pathname);
    } catch (err) {
      setTokenNotFound(true);
    }
  }, []);
  /**
   * 2️⃣ Initiate Onfido once token is ready
   */
  useEffect(() => {
    if (haveValue(userToken?.tenant_id) && haveValue(userToken?.raw_token)) {
      initiateOnfido();
    }
  }, [userToken]);
  const initiateOnfido = async () => {
    if (MOCK_ONFIDO) {
      setKycSuccess(true);
      return;
    }
    setOnfidoInitiateLoading(true);
    const url = `${process.env.REACT_APP_SERVER_URL}/api/v1/tenants/kyc/${userToken?.tenant_id}?token=${userToken?.raw_token}&extTenant=true`;
    try {
      const res = await initiateModuleUserKyc(url, {
        headers: {
          "x-modular-key": userToken.user_token,
        },
      });
      setOnfidoInitiateLoading(false);
      initiateKyc(res.sdk_data.token, res.workflow_data.id);
    } catch (error) {
      console.log("Error asdf", error);
      setOnfidoInitiateLoading(false);
      toast.error(_t("failedToVerify"));
    }
  };
  const initiateKyc = (token, workflowRunId) => {
    setOnfidoInitiateLoading(true);
    let onfido = {};
    onfido = Onfido.init({
      token,
      containerId: "onfido-mount",
      language: localStorage.getItem("i18nextLng") === "es" ? "es" : "en_US",
      workflowRunId,
      theme: {
        name: "light",
        config: {
          colorBackgroundButtonPrimary: "#253837",
          colorBorderButtonPrimary: "#253837",
          colorBackgroundButtonPrimaryHover: "#a3eb64",
          colorBorderButtonPrimaryHover: "#a3eb64",
          colorBorderSurfaceModal: "transparent",
          colorBackgroundSurfaceModal: "transparent",
          colorBorderButtonPrimaryActive: "#a3eb64",
          colorBackgroundButtonPrimaryActive: "#a3eb64",
          colorBorderButtonPrimaryFocus: "#a3eb64",
          borderRadiusButton: "18px",
          colorBorderButtonSecondary: "#253837",
          colorBorderButtonSecondaryHover: "#a3eb64",
          colorBorderButtonSecondaryActive: "#a3eb64",
          colorBorderButtonSecondaryFocus: "#a3eb64",
          colorContentButtonSecondaryText: "#253837",
          colorBackgroundButtonSecondary: "transparent",
          colorBackgroundButtonSecondaryHover: "transparent",
          colorBorderDocTypeButtonHover: "#a3eb64",
          colorBackgroundButtonTertiaryHover: "#a3eb64",
          colorBackgroundDropdownItemHover: "#a3eb64",
          colorBackgroundDropdownItemActive: "#253837",
          colorContentLinkTextHover: "#a3eb64",
          colorBorderLinkUnderline: "#253837",
        },
      },
      onComplete: async (data) => {
        setKycSuccess(true);
        setOnfidoInitiateLoading(false);
        window.parent.postMessage("KYC_COMPLETED", "*");
        onfido.tearDown();
        await saveOnfidoKycResponse(data);
      },
      onError: (err) => {
        console.log("Error", err);
        toast.error(_t("failedToVerify"));
        window.parent.postMessage("KYC_ERROR", "*");
        setOnfidoInitiateLoading(false);
      },
      onUserExit: () => {
        window.parent.postMessage("KYC_USER_EXIT", "*");
        setOnfidoInitiateLoading(false);
      },
    });
  };
  const saveOnfidoKycResponse = async (kycData) => {
    await extTenantOnfidoKyc(
      userToken.tenant_id,
      kycData,
      `?token=${userToken.raw_token}&extTenant=true`,
      userToken?.user_token
    );
  };
  if (kycSuccess) {
    return (
      <div
        style={{ height: "100vh" }}
        className="dgboxsetup authenticateModal d-flex align-items-center justify-content-center"
      >
        <div className="text-center">
          <p>{_t("kycSuccess")}</p>
        </div>
      </div>
    );
  }
  if (tokenNotFound) {
    return (
      <div
        style={{ height: "100vh" }}
        className="dgboxsetup authenticateModal d-flex align-items-center justify-content-center"
      >
        <div className="text-center">
          <p>{_t("invalidOrExpiredToken")}</p>
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="onfido-overlay">
        <div className="onfido-wrapper">
          <div id="onfido-mount"></div>
        </div>
      </div>
      {onfidoInitiateLoading && (
        <div
          style={{ height: "100vh" }}
          className="dgboxsetup authenticateModal dgboxsetup2"
        >
          <div className="defaultSkorLoaderParent">
            <img
              src={SkorDefaultLoader}
              className="defaultSkorLoader"
              alt="Loading"
            />
          </div>
        </div>
      )}
    </>
  );
};
export default ExtKycVerification;
